/**
 * useSliderSettings - Reusable slider configuration hook
 */

import { useMemo } from 'react';

export const useSliderSettings = (customSettings = {}) => {
  const defaultSettings = useMemo(() => ({
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ],
    ...customSettings
  }), [customSettings]);

  return defaultSettings;
};
